/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Thumbnail_Drop_Failed_ToastInputs */

const en_explorer_thumbnail_drop_failed_toast = /** @type {(inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drop failed: ${i?.error}`)
};

const fr_explorer_thumbnail_drop_failed_toast = /** @type {(inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deposer echoue : ${i?.error}`)
};

const de_explorer_thumbnail_drop_failed_toast = /** @type {(inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abwurf fehlgeschlagen: ${i?.error}`)
};

const it_explorer_thumbnail_drop_failed_toast = /** @type {(inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rilascio fallito: ${i?.error}`)
};

const ru_explorer_thumbnail_drop_failed_toast = /** @type {(inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при сбросе: ${i?.error}`)
};

const es_explorer_thumbnail_drop_failed_toast = /** @type {(inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fallo en la entrega: ${i?.error}`)
};

const zh_cn2_explorer_thumbnail_drop_failed_toast = /** @type {(inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`掉落失败：${i?.error}`)
};

const ja_explorer_thumbnail_drop_failed_toast = /** @type {(inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ドロップに失敗しました: ${i?.error}`)
};

const hi_explorer_thumbnail_drop_failed_toast = /** @type {(inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ड्रॉप विफल: ${i?.error}`)
};

const pt_pt2_explorer_thumbnail_drop_failed_toast = /** @type {(inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha na queda: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Drop failed: {error}" |
*
* @param {Explorer_Thumbnail_Drop_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_drop_failed_toast = /** @type {((inputs: Explorer_Thumbnail_Drop_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Drop_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_drop_failed_toast(inputs)
	if (locale === "de") return de_explorer_thumbnail_drop_failed_toast(inputs)
	if (locale === "it") return it_explorer_thumbnail_drop_failed_toast(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_drop_failed_toast(inputs)
	if (locale === "es") return es_explorer_thumbnail_drop_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_drop_failed_toast(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_drop_failed_toast(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_drop_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_drop_failed_toast(inputs)
	return en_explorer_thumbnail_drop_failed_toast(inputs)
});